import { Controller } from "@hotwired/stimulus";
import ConfirmationModalService from "../services/confirmation_modal_service";

export default class extends Controller {
  connect() {
    ConfirmationModalService.reset(this.element);
  }
}
